import { Box, Flex, Text, Icon, useToast, VStack, Heading } from '@chakra-ui/react';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import about from './assets/images/about.png'

const About = () => {
    const { t } = useTranslation();
    const toast = useToast();

    return (
        <Box as="section" px={5} pt={20} pb={20} bg="white">
            <Flex
                alignItems="center"
                flexDirection={{ base: 'column', md: 'row' }}
                justify="space-between"
                mx="auto"
                maxWidth="1200px"
                px={4}
                gap={12}
            >
                {/* About Image */}
                <Box 
                    flex="1" 
                    display={"flex"}
                    position="relative"
                    animation="fadeIn 1s ease-out"
                    alignItems={"center"}
                    justifyContent={"center"}
                >
                    {/* <Box
                        position="absolute"
                        w="100%"
                        h="100%"
                        // bgGradient="radial(cyan.400, blue.500)"
                        filter="blur(40px)"
                        opacity={0.2}
                        zIndex={-1}
                    /> */}
                    <Box
                        as="img"
                        src={about}
                        alt="About APA"
                        w={{ base: '60%', md: '100%' ,lg:'80%'}}
                        h="auto"
                        // maxH="550px"
                        objectFit="cover"
                        borderRadius="3xl"
                        boxShadow="xl"
                    />
                </Box>

                {/* About Content */}
                <VStack 
                    flex="1" 
                    align={{ base: 'center', lg: 'flex-start' }} 
                    spacing={6}
                    textAlign={{ base: 'center', lg: 'left' }}
                >
                    <Heading 
                        as="h2" 
                        size="2xl"
                        bgGradient="linear(to-r, cyan.600, blue.600)"
                        bgClip="text"
                    >
                        {t("Découvrez une nouvelle expérience !")}
                    </Heading>
                    <Text fontSize="lg" color="gray.600">
                        {t("APA vous connecte à des biens immobiliers uniques, des offres exclusives et un réseau d'agences de confiance. Que vous cherchiez à acheter, louer ou découvrir des opportunités, nous sommes là pour vous guider à chaque étape.")}
                    </Text>
                    <Text 
                        fontSize="lg" 
                        fontWeight="bold" 
                        color="cyan.600"
                    >
                        {t("Téléchargez l'application dès maintenant !")}
                    </Text>

                    <Flex 
                        w="100%" 
                        justifyContent={{ base: 'center', lg: 'flex-start' }} 
                        gap={4} 
                        flexWrap="wrap"
                    >
                        <Flex
                            as="a"
href="/Release/android/APA_PREMIUM_V1.3.4.apk"
                                download
                                        align="center"
                            p={3}
                            px={5}
                            borderRadius="lg"
                            bg="black"
                            _hover={{ bg: 'gray.800', transform: 'scale(1.05)' }}
                            transition="all 0.3s"
                            boxShadow="lg"
                            cursor="pointer"
                            // onClick={(e) => {
                            //     e.preventDefault();
                            //     toast({
                            //         title: t("Bientôt disponible sur le Play Store !"),
                            //         position: "top",
                            //         isClosable: true,
                            //         status: "info",
                            //         duration: 3000,
                            //     });
                            // }}
                        >
                            <Icon as={FaGooglePlay} boxSize={6} color="white" />
                            <Box ml={3}>
                                <Text fontSize="xs" color="whiteAlpha.800">
                                    Android
                                </Text>
                                <Text fontSize="sm" fontWeight="bold" color="white">
                                    {t("Télécharger maintenant")}
                                </Text>
                            </Box>
                        </Flex>
                        
                        <Flex
                            as="a"
                            align="center"
                            p={3}
                            px={5}
                            cursor="pointer"
                            borderRadius="lg"
                            bg="black"
                            _hover={{ bg: 'gray.800', transform: 'scale(1.05)' }}
                            transition="all 0.3s"
                            boxShadow="lg"
                            onClick={() => window.open("https://apps.apple.com/ma/app/apa-premium/id6480427570?l=fr-FR", '_blank')}
                        >
                            <Icon as={FaApple} boxSize={6} color="white" />
                            <Box ml={3}>
                                <Text fontSize="xs" color="whiteAlpha.800">
                                    App Store
                                </Text>
                                <Text fontSize="sm" fontWeight="bold" color="white">
                                    {t("Télécharger maintenant")}
                                </Text>
                            </Box>
                        </Flex>
                    </Flex>
                </VStack>
            </Flex>
        </Box>
    );
};

export default About;